import { differenceInMinutes } from 'date-fns';

export const deliveryCompleteTimeout = (
  currentOrderTime: string,
  timeoutInMinutes: number
): boolean =>
  Math.abs(differenceInMinutes(new Date(currentOrderTime), new Date())) > timeoutInMinutes;
